import Lenis from 'lenis';

import SmoothScroll from '../singleton/SmoothScroll';
import WindowSize from '../singleton/WindowSize';

class Header {
  private windowSize: WindowSize;
  $header: JQuery<HTMLElement>;
  $body: JQuery<HTMLElement>;
  $hamburger: JQuery<HTMLElement>;
  $nav: JQuery<HTMLElement>;
  // $navLinks: JQuery<HTMLElement>;

  headerIsOpened: boolean;
  isDark: boolean;
  isHome: boolean;
  threshold: number;
  smoothScroll: typeof SmoothScroll;

  constructor() {
    this.$header = jQuery('.header');
    this.$body = jQuery('body');
    this.$hamburger = this.$header.find('.header__hamburger');
    this.$nav = this.$header.find('.header__nav');
    // this.$navLinks = this.$nav.find('a.nav-link');

    this.headerIsOpened = false;
    this.isDark = false;
    this.isHome = this.$body.hasClass('home');
    this.threshold = 100;

    this.windowSize = WindowSize.getInstance();
    this.smoothScroll = SmoothScroll;

    this.init();
  }

  init() {
    this.$hamburger.on('click', this.onHamburgerClick.bind(this));
    this.smoothScroll.scroll.on('scroll', this.onScroll.bind(this));
    this.windowSize.addListener(this.onResize.bind(this));
    // this.$navLinks.on('click', this.onNavLinkClick.bind(this));
  }

  // onNavLinkClick(e: JQuery.ClickEvent) {
  //   const $link = jQuery(e.currentTarget);
  //   const $parent = $link.closest('li');
  //   const isExpanded = $parent.attr('aria-expanded') === 'true';

  //   if (!isExpanded) {
  //     e.preventDefault();
  //     $parent.attr('aria-expanded', 'true');
  //     $parent.siblings('li').attr('aria-expanded', 'false');
  //   }
  // }

  onHamburgerClick() {
    if (!this.headerIsOpened) {
      this.openNav();
    } else {
      this.closeNav();
    }
  }

  openNav() {
    this.smoothScroll.disableScrolling();
    this.$nav.attr('aria-expanded', 'true');
    this.$hamburger.attr('aria-expanded', 'true');
    this.$header.addClass('is-opened');

    this.headerIsOpened = true;
  }

  closeNav() {
    this.$nav.attr('aria-expanded', 'false');
    this.$hamburger.attr('aria-expanded', 'false');
    this.$header.removeClass('is-opened');

    this.smoothScroll.enableScrolling();

    this.headerIsOpened = false;
  }

  onResize() {
    if (this.headerIsOpened) {
      this.closeNav();
    }
  }

  onScroll(e: Lenis) {
    const st = e.scroll;

    if (e.isStopped) return;

    if (e.direction === -1) {
      this.$header.addClass('is-scrolling-up');
    } else {
      this.$header.removeClass('is-scrolling-up');
    }

    if (st > this.threshold) {
      this.$header.addClass('is-scrolling');
    } else {
      this.$header.removeClass('is-scrolling');
    }
  }
}

export default Header;
